var React = require('react');

class SaveAndExitButton extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (this.props.currentStep >= 3 && this.props.currentStep < 6) ? <div className={"change-step-container"}>
            <button onClick={this.props.saveAndExit} tabIndex="1">Save & Exit</button>
        </div> : null;
    }
}

module.exports = SaveAndExitButton;